import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      authReady: false,

      setAuth: (user, accessToken) => {
        set({ user, accessToken });
      },

      setUser: (user) => set({ user }),

      setAccessToken: (accessToken) => set({ accessToken }),

      setAuthReady: () => set({ authReady: true }),

      logout: () => set({ user: null, accessToken: null }),

      isAuthenticated: () => Boolean(get().accessToken),

      isPaid: () => get().user?.tier === 'paid',
    }),
    {
      name: 'auth-store',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
      }),
    }
  )
);
